import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "MedicationAlert"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.5 14.25H18V18H16.5V14.25ZM11.25 17.25C11.25 20.5637 13.9363 23.25 17.25 23.25C20.5637 23.25 23.25 20.5637 23.25 17.25C23.25 13.9363 20.5637 11.25 17.25 11.25C13.9363 11.25 11.25 13.9363 11.25 17.25ZM12.75 17.25C12.75 14.7647 14.7647 12.75 17.25 12.75C19.7353 12.75 21.75 14.7647 21.75 17.25C21.75 19.7353 19.7353 21.75 17.25 21.75C14.7647 21.75 12.75 19.7353 12.75 17.25ZM17.25 20.25C17.6642 20.25 18 19.9142 18 19.5C18 19.0858 17.6642 18.75 17.25 18.75C16.8358 18.75 16.5 19.0858 16.5 19.5C16.5 19.9142 16.8358 20.25 17.25 20.25ZM15 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V6C1.5 6.82843 2.17157 7.5 3 7.5V21C3 21.8284 3.67157 22.5 4.5 22.5H10.5V21H4.5V19.5H8.25V9H4.5V7.5H13.5V9.75H15V7.5C15.8284 7.5 16.5 6.82843 16.5 6V3C16.5 2.17157 15.8284 1.5 15 1.5ZM6.75 10.5V18H4.5V10.5H6.75ZM3 3V6H15V3H3Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/MedicationAlert.vue"]]);
